<template>
  <div>
    <div class="c-box">
      <header class="c-box__heading" @click="toggleVariationInfo">
        <span class="check-box" v-bind:class="selectClass" @click="select"></span>
        <span v-once>{{ variationTitle() }}</span>
        <i v-bind:class="toggleIconClass()" class="u-floatRight"></i>
        <span v-if="getErrorsBySku(variation.sku)" class="badge u-floatRight to-fix">{{ $t('to-fix').label }}</span>
      </header>
      <div class="c-box__body" v-show="show">
        <div class="c-box__inner">
          <panel title="Informações da variação">
            <div slot="header-right">
              <button class="btn btn--sm btn--info btn-history" @click="showPriceHistory(variation.sku)">
                <i class="icon-folder-search"></i>
                <span>Histórico de alteração de preços</span>
              </button>
            </div>

            <variation-attributes :variation="variation"  :fromModule="fromModule" :productId="productId"/>
          </panel>

          <panel title="Atributos" v-if="category.variations_attributes">
            <attributes :product="variation" :attributes="category.variations_attributes" :sourceVariation="sourceVariation"/>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Panel from '@/components/template/Panel'
import Attributes from '@/components/marketplace/mercadoLivre/announcement/edit/variation/Attributes'
import VariationAttributes from '@/components/marketplace/mercadoLivre/announcement/variation/VariationAttributes'

export default {
  data: () => ({
    show: false,
    selected: true
  }),
  props: {
    variation: {
      type: Object,
      required: true
    },
    sourceVariation: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    productId: {
      type: String
    },
    product: {
      type: Object
    }
  },
  mounted () {
    this.selected = this.variation.selected

    const variationAttributes = this.category.variations_attributes

    for (let i in variationAttributes) {
      if (variationAttributes[i].id === 'SIZE_GRID_ROW_ID') {
        if (typeof this.product.sizeGrid === 'undefined' || this.product.sizeGrid.length === 0) {
          this.$delete(variationAttributes[i], 'values')
          continue
        }

        variationAttributes[i].values = this.product.sizeGrid

        this.sizeGridBrand = this.product.attributes['BRAND']
        this.sizeGridId = this.product.attributes['GENDER']
      }
    }
  },
  methods: {
    fillAttributes () {
      const variationAttributes = this.category.variations_attributes
      for (let i in variationAttributes) {
        if (variationAttributes[i].id === 'SIZE_GRID_ROW_ID') {
          this.$delete(variationAttributes[i], 'values')

          this.category.variations_attributes[i].values = this.product.sizeGrid

          variationAttributes[i].values = this.product.sizeGrid
        }
      }
    },
    toggleVariationInfo (event) {
      this.fillAttributes()

      if (event.target.classList.value.indexOf('check-box') !== -1) {
        return false
      }

      this.show = !this.show
    },
    toggleIconClass () {
      return {
        'icon-circle-up': this.show,
        'icon-circle-down': !this.show
      }
    },
    variationTitle () {
      if (!this.variation || !this.sourceVariation) {
        return false
      }

      const title = [`SKU: ${this.sourceVariation.sku}`]

      if (this.sourceVariation.ean !== null && this.sourceVariation.ean !== undefined && this.sourceVariation.ean !== '') {
        title.push(`EAN: ${this.sourceVariation.ean}`)
      }

      for (let i in Object.keys(this.sourceVariation.attributes)) {
        const name = Object.keys(this.sourceVariation.attributes)[i]
        const value = this.sourceVariation.attributes[name]

        if (value === null || value === undefined) {
          continue
        }

        title.push(`${this.$t(`${name}.label`)}: ${value}`)
      }

      title.push(`Estoque: ${this.sourceVariation.quantity}`)

      return title.join(' | ')
    },
    select (event) {
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        event.target instanceof HTMLSelectElement ||
        event.target.parent instanceof HTMLButtonElement ||
        event.target.classList.value.indexOf('icon') !== -1 ||
        this.blockSelect
      ) {
        return false
      }

      this.selected = !this.selected
      this.onClickVariation(this.selected)
    },
    onClickVariation (selected) {
      this.variation.selected = selected
    },
    showPriceHistory (sku) {
      this.$parent.$parent.showPriceHistory(sku)
    }
  },
  computed: {
    ...mapGetters('errors', [
      'getErrorsBySku'
    ]),
    selectClass () {
      return {
        'checked': this.selected
      }
    }
  },
  components: {
    Panel,
    Attributes,
    VariationAttributes
  }
}
</script>

<style lang="sass" scoped>
  .c-box
    margin-bottom: 16px

    .c-box__body
      background: #d9edf7

    .c-box__heading
      cursor: pointer
      height: 50px
      line-height: 2
      font-size: 15px
      color: #31708f
      background-color: #d9edf7
      border-color: #bde2fb

    .icon-circle-down, .icon-circle-up
      font-size: 30px

    .c-box__body
      border-color: #bde2fb

  .check-box
    border-color: #7872ff

  .badge
    margin: 4px 7px 0 0
</style>



// WEBPACK FOOTER //
// Multi.vue?661628de